import { render, staticRenderFns } from "./CompanyNewRegistration.vue?vue&type=template&id=86a4ab5e&scoped=true"
import script from "./CompanyNewRegistration.vue?vue&type=script&lang=js"
export * from "./CompanyNewRegistration.vue?vue&type=script&lang=js"
import style0 from "./CompanyNewRegistration.vue?vue&type=style&index=0&id=86a4ab5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a4ab5e",
  null
  
)

export default component.exports